export default {
    API_BASE_URL: "https://apidev.optimocapital.in",
    API_BASE_URL_NEW: "https://napidev.optimocapital.in",
    CUSTOMER_FORM_URL: "https://loandev.optimocapital.in",
    optimo_whatsapp_number: '918970507206',
    WEBSOCKET_URL: "wss://4pk27tvl3c.execute-api.ap-south-1.amazonaws.com/dev",
    DIGIO_ENVIRONMENT: "sandbox",
};